export default function initBuilderViews() {
  const triggers = document.querySelectorAll("[data-trigger-builder-view]");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();

      // Get the view value and find the target
      const viewValue = trigger.getAttribute("data-trigger-builder-view");
      const target = document.querySelector(
        `[data-builder-view="${viewValue}"]`
      );

      if (!target) {
        console.warn(`No target found for data-builder-view="${viewValue}"`);
        return;
      }

      // Determine which wrapper contains this trigger (if any)
      const interiorWrapper = trigger.closest("[data-main-view=furniture]");
      const furnitureWrapper = trigger.closest("[data-main-view=builder]");

      // Set the current wrapper context
      const currentWrapper = interiorWrapper || furnitureWrapper;
      // console.log("Current wrapper:", currentWrapper);

      trigger.classList.add("is-active");
      target.classList.remove("hidden");

      const siblings = currentWrapper.querySelectorAll(
        `[data-builder-view]:not([data-builder-view="${viewValue}"])`
      );

      siblings.forEach((sibling) => {
        sibling.classList.add("hidden");
      });

      const siblingTriggers = currentWrapper.querySelectorAll(
        `[data-trigger-builder-view]:not([data-trigger-builder-view="${viewValue}"])`
      );

      siblingTriggers.forEach((siblingTrigger) => {
        siblingTrigger.classList.remove("is-active");
      });
    });
  });
}
